import { createPermission } from '@backstage/plugin-permission-common';

export const pagerDutyAdminPermission = createPermission({
  name: 'hone.integrations.pagerduty.settings.manage',
  attributes: {},
});

export const pagerDutyIncidentHistoryReadPermission = createPermission({
  name: 'hone.integrations.pagerduty.incidents.read',
  attributes: { action: 'read' },
});
